import { render, staticRenderFns } from "./wxrateview.vue?vue&type=template&id=20c6c8dc&scoped=true&"
import script from "./wxrateview.vue?vue&type=script&lang=js&"
export * from "./wxrateview.vue?vue&type=script&lang=js&"
import style0 from "./wxrateview.vue?vue&type=style&index=0&id=20c6c8dc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c6c8dc",
  null
  
)

export default component.exports